import { paths } from "../../../../../common/constants";

export default {
  items: [
    {
      name: "Dashboard",
      url: paths.client.ADMIN_DASHBOARD,
      icon: "fa fa-pie-chart",
    },
    {
      name: "Admins",
      url: paths.client.ADMIN_ADMINS,
      icon: "icon-user",
    },
    {
      name: "Customers",
      url: paths.client.ADMIN_CUSTOMERS,
      icon: "icon-people",
    },
    {
      name: "Posts",
      url: paths.client.ADMIN_POSTS,
      icon: "icon-picture",
    },
    {
      name: "Trip Plans",
      url: "/page",
      icon: "icon-pin",
      children: [
        {
          name: "Upcoming",
          url: paths.client.ADMIN_TRIP_PLANS_UPCOMING,
        },
        {
          name: "Past",
          url: paths.client.ADMIN_TRIP_PLANS_PAST,
        },
      ],
    },
    {
      name: "Transactions",
      url: paths.client.ADMIN_TRANSACTIONS,
      icon: "icon-credit-card",
    },
    {
      name: "Report",
      url: paths.client.ADMIN_REPORT,
      icon: "fa fa-chart-bar",
    },
    {
      name: "Notification",
      url: paths.client.ADMIN_PUSH_NOTIFICATION,
      icon: "fa fa-bell",
    },
  ],
};



// WEBPACK FOOTER //
// ./client/react/Admin/components/Sidebar/_nav.js